// extracted by mini-css-extract-plugin
export var menuItem = "v_tg d_fZ d_bz d_bD d_bP d_bf";
export var menuItemSub = "v_th d_Z d_bz d_bP";
export var menuMainLink = "v_tj d_f0 d_dB";
export var menuLink = "v_tk d_f0 d_dB";
export var icon = "v_p9 d_bC d_bP";
export var divider = "v_tl d_bC d_bP";
export var sublinks = "v_tm";
export var link = "v_mC";
export var Link = "v_rm q_rm q_qD q_qY";